import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function ProtectedRoute({ children, role }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const hasRole = role === 'tenant-admin'
    ? user.role === 'admin'
    : role === 'admin'
      ? (user.role === 'admin' || user.role === 'superadmin')
      : user.role === role;

  if (role && !hasRole) {
    return <Navigate to="/" replace />;
  }

  return children;
}
